import Spinner from "src/components/Spinner";

const colors = {
  green: "text-[#26993F] bg-[rgba(38,153,63,0.05)]",
  black: "bg-[rgba(20,20,20,0.05)]",
  yellow: "bg-[rgba(255,145,77,0.05)] text-[#FF914D]",
  red: "text-[#FF5757] bg-[rgba(255,87,87,0.05)]"
};

export const CountCard = ({
  count,
  title,
  color = "black"
}: {
  count?: number;
  title: string;
  color?: keyof typeof colors;
}) => (
  <div className="w-fit h-[62px] px-4 py-3 flex gap-16 items-center rounded-2xl border-[1px] border-[rgba(95,95,255,0.20)]">
    <p className="font-poppins text-base font-semibold">{title}</p>
    <p className={`px-2 py-1 font-poppins text-xl font-semibold rounded-lg ${colors[color]} `}>
      {count === undefined ? <Spinner /> : count}
    </p>
  </div>
);
